module.exports = __webpack_public_path__ + "static_portal/img/pdf_report_steve.cae85e86.jpg";